<template>
  <div>
    <el-dialog
        :title="'Thông tin điểm danh: ' + (attendanceData ? attendanceData.nameStudent : '')"
        :visible.sync="dialogVisible"
        width="800px"
        :before-close="closeDialogByButton"
        :close-on-click-modal="false"
        top="6vh"
        custom-class="premium-attendance-dialog"
    >
      <el-form
          v-if="attendanceData"
          label-width="120px"
          :model="attendanceData"
          label-position="top"
          ref="attendanceKid"
          class="timeline-form"
      >
        <div class="timeline-container">
          <div class="timeline-line"></div>

          <!-- Bước 1: Đến -->
          <div class="timeline-item checkin">
            <div class="timeline-badge checkin-badge">
              <i class="el-icon-sunrise" />
            </div>

            <div class="timeline-uploader-wrapper">
              <div class="uploader-title">ẢNH ĐẾN</div>
              <div class="uploader-and-clock">
                <image-uploader
                    v-model="imageArriveUpload"
                    :preview="attendanceData.urlPictureArrive"
                    placeholder="Tải ảnh đến"
                    :updateAttendance="isDisabledUploadImage()"
                />
                
                <!-- Đồng hồ Tròn & Số điện tử ngay cạnh ảnh -->
                <div class="visual-clock-container" v-if="attendanceData.arriveTime">
                  <div class="analog-clock">
                    <div class="clock-face">
                      <div class="clock-dot"></div>
                      <div class="clock-hand hour" :style="{ transform: getClockHandsRotation(attendanceData.arriveTime).hour }"></div>
                      <div class="clock-hand minute" :style="{ transform: getClockHandsRotation(attendanceData.arriveTime).minute }"></div>
                    </div>
                  </div>
                  <div class="digital-clock">
                    <i class="el-icon-time" />
                    <span>{{ attendanceData.arriveTime | formatTime }}</span>
                  </div>
                </div>
                <div class="no-time-badge" v-else>
                  <i class="el-icon-warning" /> Chưa check-in
                </div>
              </div>
            </div>
          </div>

          <!-- Bước 2: Về -->
          <div class="timeline-item checkout">
            <div class="timeline-badge checkout-badge">
              <i class="el-icon-sunset" />
            </div>

            <div class="timeline-uploader-wrapper">
              <div class="uploader-title">ẢNH VỀ</div>
              <div class="uploader-and-clock">
                <image-uploader
                    v-model="imageLeaveUpload"
                    :preview="attendanceData.urlPictureLeave"
                    placeholder="Tải ảnh về"
                    :updateAttendance="isDisabledUploadImage()"
                />
                
                <!-- Đồng hồ Tròn & Số điện tử ngay cạnh ảnh -->
                <div class="visual-clock-container" v-if="attendanceData.leaveTime">
                  <div class="analog-clock">
                    <div class="clock-face">
                      <div class="clock-dot"></div>
                      <div class="clock-hand hour" :style="{ transform: getClockHandsRotation(attendanceData.leaveTime).hour }"></div>
                      <div class="clock-hand minute" :style="{ transform: getClockHandsRotation(attendanceData.leaveTime).minute }"></div>
                    </div>
                  </div>
                  <div class="digital-clock">
                    <i class="el-icon-time" />
                    <span>{{ attendanceData.leaveTime | formatTime }}</span>
                  </div>
                </div>
                <div class="no-time-badge" v-else>
                  <i class="el-icon-warning" /> Chưa check-out
                </div>
              </div>
            </div>
          </div>

          <!-- Bước 3: Ghi chú chung -->
          <div class="timeline-item note">
            <div class="timeline-badge note-badge">
              <i class="el-icon-edit-outline" />
            </div>

            <div class="timeline-card note-card">
              <div class="card-header">
                <span class="card-title">GHI CHÚ CHUNG</span>
              </div>
              <div class="card-body">
                <div class="custom-attendance-status-container">
                  <div class="note-input-section">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="Nhập nội dung ghi chú..."
                        :value="getAttendanceNote()"
                        @input="val => onChangeNote(val)"
                        class="premium-textarea"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bước 4: Người thực hiện -->
          <div class="timeline-item info-meta" v-if="attendanceData.createdBy || attendanceData.createdDate">
            <div class="timeline-badge info-badge">
              <i class="el-icon-user-solid" />
            </div>

            <div class="timeline-card info-card">
              <div class="card-body meta-body">
                <div class="meta-row" v-if="attendanceData.createdBy">
                  <i class="el-icon-user icon-blue" />
                  <span class="meta-label">Người tạo:</span>
                  <strong class="meta-value">{{ attendanceData.createdBy }}</strong>
                </div>
                <div class="meta-row" v-if="attendanceData.createdDate">
                  <i class="el-icon-time icon-blue" />
                  <span class="meta-label">Thời gian tạo:</span>
                  <span class="meta-value">{{ attendanceData.createdDate | formatDateTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Lịch sử chỉnh sửa collapsible -->
        <div class="edit-history-section">
          <div class="history-toggle" @click.stop="fetchEditHistoryAttendance()">
            <span class="toggle-title">
              <i class="el-icon-notebook-2" /> Lịch sử chỉnh sửa điểm danh
            </span>
            <el-button size="mini" type="text" class="toggle-btn">
              {{ editHistory == null ? "Hiện lịch sử" : "Ẩn lịch sử" }}
              <i :class="editHistory == null ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" />
            </el-button>
          </div>

          <transition name="el-zoom-in-top">
            <div class="history-timeline-container" v-if="editHistory != null">
              <div v-loading="isLoadingHistory" class="history-timeline-loading-wrapper">
                <div v-if="editHistory.length === 0" class="no-history-text">
                  Chưa có lịch sử chỉnh sửa nào.
                </div>
                <div v-else class="history-timeline">
                  <div class="history-timeline-line"></div>
                  
                  <div 
                      v-for="(row, rIdx) in editHistory" 
                      :key="rIdx" 
                      class="history-timeline-item"
                  >
                    <div class="history-timeline-badge">
                      <i class="el-icon-edit" />
                    </div>
                    <div class="history-timeline-panel">
                      <div class="history-panel-header">
                        <span class="editor-name">
                          <i class="el-icon-user" /> {{ row.createdBy }}
                        </span>
                        <span class="editor-time">
                          <i class="el-icon-time" /> {{ row.createdDate | formatDateTime }}
                        </span>
                      </div>
                      <div class="history-panel-body">
                        <div 
                            v-for="(change, cIdx) in row.contentChanges" 
                            :key="cIdx" 
                            class="change-detail-row"
                        >
                          <i class="el-icon-caret-right" /> {{ change }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </el-form>

      <!-- Safe Loading Spinner when attendanceData is null -->
      <div v-else class="dialog-loading-container">
        <i class="el-icon-loading spinner-icon"></i>
        <span>Đang tải thông tin điểm danh...</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
            type="success"
            size="medium"
            :loading="isLoadingSave"
            @click="saveAttendance()"
            class="footer-btn save-btn"
        >
          <i class="el-icon-circle-check" /> Lưu thay đổi
        </el-button>
        <el-button 
            type="info" 
            size="medium"
            @click="closeDialogByButton()"
            class="footer-btn close-btn"
        >
          <i class="el-icon-circle-close" /> Đóng
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageUploader from "@/utils/view/ImageUploader.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import shiftMaster from "@/services/ShiftMaster";
import AttendanceV3Service from "@/attendance_v3/services/AttendanceV3Service";

export default {
  name: "AttendanceUpdateAction",
  components: {
    ImageUploader,
  },
  props: {
    dialogVisible: {type: Boolean, default: false},
    type: {type: String, required: true},
  },
  data() {
    return {
      attendanceData: null,
      attendanceMap: {},
      imageArriveUpload: null,
      imageLeaveUpload: null,
      editHistory: null,

      isLoadingHistory: false,
      isLoadingSave: false,
    };
  },
  methods: {
    closeDialog() {
      if (this.attendanceData != null) {
        const id = this.attendanceData.idStudent;
        const state = this.attendanceMap[id];
        if (state) {
          state.editing = Object.assign({}, state.original);
        }
      }
      this.isUpdateAttendance = false;
      this.editHistory = null;
      this.imageArriveUpload = null;
      this.imageLeaveUpload = null;
      this.$emit("close");
    },

    closeDialogByButton() {
      this.closeDialog();
    },

    clearUploadedFiles() {
      this.shiftList.forEach(shift => {
        this.$set(shift, "checkinImage", null);
        this.$set(shift, "checkoutImage", null);
      });
      this.shiftList = [];
      this.attendanceKidRow = null;
      this.fullNameTitle = "";
      this.recordId = "";
      this.showHistoryUpdateAttendance = false;
    },

    // ==================== LƯU ĐIỂM DANH ====================
    submitForm(formRef) {
      if (!this.$refs[formRef]) {
        this.$message.error("Form ref không tồn tại");
        return;
      }

      this.$refs[formRef].validate(async (valid) => {
        if (!valid) {
          this.$message.error("Vui lòng kiểm tra thông tin trước khi lưu");
          return;
        }

        const requests = this.shiftList.map(shift => {
          const formData = new FormData();

          formData.append("teamId", this.teamId || "");
          formData.append("targetType", this.attendanceKidRow?.targetType || "STUDENT");
          formData.append("targetId", this.attendanceKidRow?.targetId || "");
          formData.append("shiftMasterId", shift.shiftId);
          formData.append("attendanceRecordDate", this.attendanceRecordDate || "");

          if (shift.checkinTime) formData.append("checkinTime", shift.checkinTime);
          if (shift.checkoutTime) formData.append("checkoutTime", shift.checkoutTime);
          if (shift.status) formData.append("status", shift.status);
          if (shift.note) formData.append("note", shift.note);

          if (shift.checkinImage instanceof File) {
            formData.append("checkinImage", shift.checkinImage, `checkin_${shift.shiftId}.jpg`);
          }
          if (shift.checkoutImage instanceof File) {
            formData.append("checkoutImage", shift.checkoutImage, `checkout_${shift.shiftId}.jpg`);
          }

          return formData;
        });

        this.loadingButton = true;

        try {
          let hasError = false;
          let errorMessages = [];

          // Gửi tuần tự để dễ debug
          for (let i = 0; i < requests.length; i++) {
            const formData = requests[i];
            const shift = this.shiftList[i];

            try {
              const response = await shiftMaster.saveAttendanceRecordOne(formData);

              if (!response || response.status !== 200) {
                hasError = true;
                errorMessages.push(`Ca ${shift.shiftName} lưu thất bại`);
              }
            } catch (err) {
              hasError = true;
              console.error(`Lỗi lưu ca ${shift.shiftName}:`, err);
              errorMessages.push(`Ca ${shift.shiftName}: ${err.response?.data?.message || "Lỗi không xác định"}`);
            }
          }

          if (hasError) {
            this.$message.error("Một số ca lưu thất bại:\n" + errorMessages.join("\n"));
          } else {
            NotifyMessage.leftCornerNotificationSuccess("Cập nhật điểm danh học sinh thành công");
          }

          this.clearUploadedFiles();
          this.closeDialogByButton();

        } catch (err) {
          console.error("Lỗi tổng quát:", err);
          this.$message.error("Cập nhật điểm danh học sinh thất bại");
        } finally {
          this.loadingButton = false;
        }
      });
    },

    saveAttendance() {
      if (this.isLoadingSave) {
        return;
      }

      this.isLoadingSave = true;

      if (!this.checkFieldDirty() && !this.imageArriveUpload && !this.imageLeaveUpload) {
        this.isLoadingSave = false;
        return;
      }

      const data = this.setupAttendanceData();

      AttendanceV3Service.saveAttendanceFile({attendances: data}).then(() => {
            // Xóa cache cũ để lần mở tiếp sẽ fetch data mới từ server
            if (this.attendanceData) {
              this.$delete(this.attendanceMap, this.attendanceData.idStudent);
            }
            this.closeDialogByButton();
            this.$message.success('Lưu điểm danh thành công')
          }
      ).catch((err) => {
        this.$message.error(err?.message || 'Lưu thất bại')
      }).finally(() => {
        this.isLoadingSave = false;
      })
    },

    checkFieldDirty() {
      const data = this.attendanceData;
      if (data == null) {
        return false;
      }

      const id = data.idStudent;
      const state = this.attendanceMap[id];
      const editing = state.editing;
      const original = state.original;

      if (!editing || !original) return false;

      return (editing.note || '') !== (original.note || '');
    },

    setupAttendanceData() {
      const type = `update-detail-${this.type}`;
      const id = this.attendanceData.idStudent;
      const state = this.attendanceMap[id];
      const editing = state.editing;
      const formData = new FormData();


      Object.entries(editing).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(`updates[0].${key}`, value);
        }
      });

      if (this.imageArriveUpload instanceof File) {
        formData.append("updates[0].pictureArrive", this.imageArriveUpload);
      }

      if (this.imageLeaveUpload instanceof File) {
        formData.append("updates[0].pictureLeave", this.imageLeaveUpload);
      }

      formData.append(`updates[0].type`, type);

      return formData;
    },

    // ==================== KHỞI TẠO DỮ LIỆU ====================
    getDataArriveRowInitial({idStudent, date, type, idGroup}) {
      AttendanceV3Service.getDetailByIdStudent({
        idStudent: idStudent,
        date: date,
        type: type,
        idGroup: idGroup
      }).then((res) => {
        const data = res.data.data;

        this.attendanceData = data;

        const id = data.idStudent;
        if (!this.attendanceMap[id]) {
          this.$set(this.attendanceMap, id, {
            original: Object.assign({}, data),
            editing: Object.assign({}, data),
            dirty: false,
            saving: false,
            error: null,
          })
        } else {
          const state = this.attendanceMap[id]
          state.original = Object.assign({}, data)
          state.editing = Object.assign({}, state.editing || data)
        }

      }).catch((err) => {
        this.$message.error(err?.message || 'Không tìm thấy thông tin điểm danh')
      }).finally(() => {
        this.loadingButton = false;
      });
    },

    getAttendanceNote() {
      return this.attendanceData != null ? this.attendanceMap[this.attendanceData.idStudent]?.editing?.note : "Xin nghỉ hôm nay ạ";
    },

    onChangeNote(value) {
      if (this.attendanceData != null) {
        const id = this.attendanceData.idStudent;

        this.attendanceMap[id].editing.note = value;
      }
    },

    handleChangeUpdate() {
      this.isUpdateAttendance = !this.isUpdateAttendance;
    },

    fetchEditHistoryAttendance() {
      if (this.editHistory == null) {
        this.isLoadingHistory = true;
        AttendanceV3Service.getEditHistoryAttendance({idAttendance: this.attendanceData.id}).then((res) => {
          this.editHistory = res.data;
        }).finally(() => {
          this.isLoadingHistory = false;
        });
      } else {
        this.editHistory = null
      }
    },

    isDisabledUploadImage() {
      return !(this.attendanceData.attendanceStatus != null && this.attendanceData.attendanceStatus !== "PRESENT");
    },

    getClockHandsRotation(timeStr) {
      if (!timeStr) return { hour: 'rotate(0deg)', minute: 'rotate(0deg)' };
      try {
        let hours = 0;
        let minutes = 0;
        if (timeStr.includes(':')) {
          const timePart = timeStr.includes('T') ? timeStr.split('T')[1] : timeStr;
          const parts = timePart.split(':');
          hours = parseInt(parts[0], 10);
          minutes = parseInt(parts[1], 10);
        } else {
          const d = new Date(timeStr);
          if (!isNaN(d.getTime())) {
            hours = d.getHours();
            minutes = d.getMinutes();
          }
        }
        const hourDeg = (hours % 12) * 30 + minutes * 0.5;
        const minDeg = minutes * 6;
        return {
          hour: `rotate(${hourDeg}deg)`,
          minute: `rotate(${minDeg}deg)`
        };
      } catch (e) {
        return { hour: 'rotate(0deg)', minute: 'rotate(0deg)' };
      }
    }
  }
};
</script>

<style scoped>
/* Dialog override styles for premium feel */
::v-deep .premium-attendance-dialog {
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

::v-deep .premium-attendance-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1e40af, #3b82f6);
  padding: 20px 24px !important;
}

::v-deep .premium-attendance-dialog .el-dialog__title {
  color: #ffffff !important;
  font-size: 20px !important;
  font-weight: 700;
  letter-spacing: 0.5px;
}

::v-deep .premium-attendance-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff !important;
  font-size: 24px;
  transition: transform 0.2s ease;
}

::v-deep .premium-attendance-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  transform: rotate(90deg);
}

::v-deep .premium-attendance-dialog .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
  background-color: #f8fafc;
  padding: 24px 30px !important;
}

::v-deep .premium-attendance-dialog .el-dialog__footer {
  background-color: #ffffff;
  padding: 16px 24px !important;
  border-top: 1px solid #e2e8f0;
}

/* Dialog Loading State */
.dialog-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #64748b;
  gap: 16px;
}

.spinner-icon {
  font-size: 40px;
  color: #3b82f6;
}

/* Timeline Container */
.timeline-container {
  position: relative;
  padding: 10px 0 20px 0;
}

/* Timeline vertical line on the left side */
.timeline-line {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  width: 4px;
  background: linear-gradient(to bottom, #3b82f6 15%, #10b981 45%, #f59e0b 75%, #64748b 95%);
  border-radius: 4px;
  z-index: 1;
}

/* Timeline Item */
.timeline-item {
  position: relative;
  padding-left: 55px;
  margin-bottom: 30px;
  min-height: 80px;
  z-index: 2;
}

/* Timeline Badge (Sunrise, Sunset, Edit icons on the line) */
.timeline-badge {
  position: absolute;
  left: 0;
  top: 4px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 3px solid #ffffff;
  z-index: 3;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.checkin-badge {
  background-color: #eff6ff;
  color: #2563eb;
  border-color: #3b82f6;
}

.note-badge {
  background-color: #fef3c7;
  color: #d97706;
  border-color: #f59e0b;
}

.checkout-badge {
  background-color: #ecfdf5;
  color: #059669;
  border-color: #10b981;
}

.info-badge {
  background-color: #f1f5f9;
  border-color: #94a3b8;
  color: #475569;
}

.timeline-item:hover .timeline-badge {
  transform: scale(1.15);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* Timeline Panel/Card */
.timeline-card {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.timeline-item:hover .timeline-card {
  transform: translateX(6px);
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e1;
}

.note-card {
  max-width: 660px;
}

.info-card {
  max-width: 450px;
}

/* Specific item focus highlight */
.timeline-item.note:hover .timeline-card {
  border-left: 4px solid #f59e0b;
}

.timeline-item.info-meta:hover .timeline-card {
  border-left: 4px solid #64748b;
}

/* Timeline Card Header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8fafc;
  padding: 10px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.card-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #475569;
}

/* Timeline Card Body */
.card-body {
  padding: 16px;
}

/* Uploader direct layout on timeline (no double card wrap) */
.timeline-uploader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.timeline-item:hover .timeline-uploader-wrapper {
  transform: translateX(6px);
}

.uploader-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #475569;
  text-transform: uppercase;
  padding-left: 2px;
}

/* Flex uploader + clock container */
.uploader-and-clock {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Glassmorphism Clock Widget container */
.visual-clock-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 4px;
  transition: all 0.3s ease;
}

.no-time-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 600;
  background-color: #f1f5f9;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
}

/* High-fidelity CSS Analog Clock */
.analog-clock {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 3px solid #2563eb;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15), inset 0 2px 4px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.checkout .analog-clock {
  border-color: #059669;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.15), inset 0 2px 4px rgba(0,0,0,0.05);
}

/* 12 o'clock tick mark */
.analog-clock::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 50%;
  width: 2px;
  height: 5px;
  background-color: #cbd5e1;
  transform: translateX(-50%);
  border-radius: 1px;
  z-index: 1;
}

/* 6 o'clock tick mark */
.analog-clock::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 50%;
  width: 2px;
  height: 5px;
  background-color: #cbd5e1;
  transform: translateX(-50%);
  border-radius: 1px;
  z-index: 1;
}

.clock-face {
  width: 100%;
  height: 100%;
  position: relative;
}

/* 9 o'clock tick mark */
.clock-face::before {
  content: '';
  position: absolute;
  left: 2px;
  top: 50%;
  width: 5px;
  height: 2px;
  background-color: #cbd5e1;
  transform: translateY(-50%);
  border-radius: 1px;
  z-index: 1;
}

/* 3 o'clock tick mark */
.clock-face::after {
  content: '';
  position: absolute;
  right: 2px;
  top: 50%;
  width: 5px;
  height: 2px;
  background-color: #cbd5e1;
  transform: translateY(-50%);
  border-radius: 1px;
  z-index: 1;
}

.clock-dot {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #1e3a8a;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.checkout .clock-dot {
  background-color: #065f46;
}

.clock-hand {
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform-origin: bottom center;
  border-radius: 4px;
  transform: translateX(-50%);
}

.clock-hand.hour {
  width: 3px;
  height: 14px;
  background-color: #1e293b;
  z-index: 3;
}

.clock-hand.minute {
  width: 2px;
  height: 19px;
  background-color: #475569;
  z-index: 2;
}

/* Premium Digital clock styling (Plain design integrated with the layout) */
.digital-clock {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.5px;
  color: #2563eb;
}

.checkout .digital-clock {
  color: #10b981;
}

.digital-clock i {
  font-size: 13px;
  animation: pulse-clock 2s infinite ease-in-out;
}

@keyframes pulse-clock {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(0.95);
  }
}

/* Custom note component style */
.premium-textarea ::v-deep .el-textarea__inner {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  padding: 10px 14px;
  transition: all 0.2s ease;
}

.premium-textarea ::v-deep .el-textarea__inner:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

/* Info metadata styles */
.meta-body {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #475569;
}

.meta-row i {
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.icon-blue {
  color: #3b82f6;
}

.meta-label {
  color: #64748b;
  font-weight: 500;
}

.meta-value {
  color: #1e293b;
}

/* Edit History Section styling */
.edit-history-section {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-top: 24px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.history-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background-color: #f8fafc;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.history-toggle:hover {
  background-color: #f1f5f9;
}

.toggle-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-title i {
  color: #3b82f6;
  font-size: 16px;
}

.toggle-btn {
  font-weight: 600;
  font-size: 13px;
}

/* History Timeline Styling */
.history-timeline-container {
  padding: 16px 20px 8px 20px;
  border-top: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.history-timeline-loading-wrapper {
  min-height: 50px;
}

.no-history-text {
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
  padding: 20px 0;
  font-style: italic;
}

.history-timeline {
  position: relative;
  padding: 8px 0;
}

.history-timeline-line {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 15px;
  width: 2px;
  background-color: #e2e8f0;
  z-index: 1;
}

.history-timeline-item {
  position: relative;
  padding-left: 42px;
  margin-bottom: 20px;
  z-index: 2;
}

.history-timeline-item:last-child {
  margin-bottom: 0;
}

.history-timeline-badge {
  position: absolute;
  left: 0;
  top: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #eff6ff;
  border: 2px solid #3b82f6;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  z-index: 3;
}

.history-timeline-panel {
  background-color: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 12px 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;
}

.history-timeline-item:hover .history-timeline-panel {
  border-color: #cbd5e1;
  background-color: #f1f5f9;
}

.history-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px dashed #cbd5e1;
}

.editor-name {
  font-weight: 600;
  color: #475569;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.editor-name i {
  color: #64748b;
}

.editor-time {
  font-size: 12px;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.history-panel-body {
  font-size: 13px;
  color: #334155;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.change-detail-row {
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.change-detail-row i {
  color: #3b82f6;
  font-size: 14px;
  margin-top: 2px;
}

/* Footer styling */
.footer-btn {
  font-weight: 600;
  padding: 10px 20px !important;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.save-btn {
  background-color: #10b981 !important;
  border-color: #10b981 !important;
}

.save-btn:hover {
  background-color: #059669 !important;
  border-color: #059669 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

.close-btn {
  background-color: #94a3b8 !important;
  border-color: #94a3b8 !important;
}

.close-btn:hover {
  background-color: #64748b !important;
  border-color: #64748b !important;
  transform: translateY(-1px);
}
</style>
